import { render, staticRenderFns } from "./Shows.vue?vue&type=template&id=523e680a&scoped=true&"
import script from "./Shows.vue?vue&type=script&lang=js&"
export * from "./Shows.vue?vue&type=script&lang=js&"
import style0 from "./Shows.vue?vue&type=style&index=0&id=523e680a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e680a",
  null
  
)

export default component.exports